import { Row, FormSelect, FormInput, FormTextArea, Widget } from '@digital/ui'
import React from 'react'
import ptBR from '@app/i18n/ptBR'
import { getAllTipoNaoPrevistoOptions } from '@app/api/naoPrevistos/parametros';
import { reloadState, solicitacaoState } from '../../../atoms';
import { useRecoilState } from 'recoil';
import { updateSolicitacaoNaoPrevisto } from '@app/api/naoPrevistos/solicitacao';
import { Collapse, Icon, Checkbox, Switch, Divider } from 'antd';
import { EStatusSolicitacaoNaoPrevisto } from '@app/enums/ENaoPrevisto';

const { Panel } = Collapse;
const MotivadorDoCapexNaoPrevisto = () => {
  const [solicitacao] = useRecoilState(solicitacaoState);
  const [reload, setReload] = useRecoilState(reloadState);

  const onBlur = (e: any) => {
    if (solicitacao[e.currentTarget.name] === e.currentTarget.value) return

    const values = { ...solicitacao, [e.currentTarget.name]: e.currentTarget.value }

    updateSolicitacaoNaoPrevisto(values).then((result) => {
      setReload(!reload)
    })
  }

  const onSelect = (value: any, property: string) => {
    if (solicitacao[property] === value) return

    const values = { ...solicitacao, [property]: value }

    updateSolicitacaoNaoPrevisto(values).then((result) => {
      setReload(!reload)
    })
  }

  return (

    <Collapse bordered={false} defaultActiveKey={['2']} expandIcon={() => <Icon type="arrows-right_4" />}>
      <Panel key="2" header={ptBR.lblProjeto} style={{ border: 0 }}>

        <Widget
          title=""
          actions={[]}>

          <Row>
            <FormInput
              span={12}
              name='nomeProjeto'
              label={ptBR.lblNomeDoProjeto}
              onBlur={onBlur}
              disabled={solicitacao.statusId !== EStatusSolicitacaoNaoPrevisto.PreenchimentoDaSolicitacao}
            />
          </Row>

          <Row>
            <FormTextArea
              span={10}
              rows={6}
              name='escopo'
              label={ptBR.lblEscopoDoProjetoEOuInvestimento}
              placeholder={ptBR.placeholder_escopo}
              onBlur={onBlur}
              disabled={solicitacao.statusId !== EStatusSolicitacaoNaoPrevisto.PreenchimentoDaSolicitacao}
            />

            <FormTextArea
              span={2}
              name='vidaUtilEmMeses'
              label={ptBR.lblVidaUtilEmMeses}
              placeholder={ptBR.placeholder_vidaUtilEmMeses}
              onBlur={onBlur}
              disabled={solicitacao.statusId !== EStatusSolicitacaoNaoPrevisto.PreenchimentoDaSolicitacao}
            />
          </Row>
          <Row>
            <FormTextArea
              span={12}
              rows={4}
              name='porQueAgora'
              placeholder={ptBR.placeholder_porQueAgora}
              label={ptBR.lblPorQueAgora}
              onBlur={onBlur}
              disabled={solicitacao.statusId !== EStatusSolicitacaoNaoPrevisto.PreenchimentoDaSolicitacao}
            />
          </Row>

          <fieldset>
            <legend className='legend-float-left'>{ptBR.lblMotivadorDoCapExNaoPrevisto}</legend>

            <Row>
              <FormSelect
                span={4}
                name='tipoNaoPrevistoId'
                label={ptBR.lblTipo}
                getOptions={getAllTipoNaoPrevistoOptions}
                onSelect={(value) => onSelect(value, 'tipoNaoPrevistoId')}
                disabled={solicitacao.statusId !== EStatusSolicitacaoNaoPrevisto.PreenchimentoDaSolicitacao}
              />

              <FormTextArea
                span={12}
                rows={4}
                name='observacao'
                placeholder={ptBR.placeholder_observacao}
                label={ptBR.lblObservacao}
                onBlur={onBlur}
                disabled={solicitacao.statusId !== EStatusSolicitacaoNaoPrevisto.PreenchimentoDaSolicitacao}
              />

            </Row>
          </fieldset>

        </Widget>
      </Panel>
    </Collapse>
  )
}

export default MotivadorDoCapexNaoPrevisto